var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-button',{staticStyle:{"border-radius":"5px","padding-bottom":"0","padding-top":"0"},attrs:{"color":"success","type":"gradient","icon":"print"},on:{"click":function($event){return _vm.faturaCiktiEvrak()}}},[_vm._v("Çıktı Al")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }